export const VITE_SERVER_BASE_URL = import.meta.env.VITE_SERVER_BASE_URL || ''
export enum CHARGE_CHANNEL {
  WeChat = 'WeChat',
  Alipay = 'Alipay',
}

export enum CURRENCY {
  CNY = 'CNY',
  USD = 'USD',
}

export enum CompanyType {
  Company = 'Company', // 公司
  Proprietorship = 'Proprietorship', // 个体工商户
}

export enum CompanyVerifyStatus {
  Verified = 'Verified', // 已认证
  Review = 'Review', // 审核中
  Rejected = 'Rejected', // 审核未通过
}

export const CompanyVerifyStatusText: Record<string, any> = {
  [CompanyVerifyStatus.Verified]: {
    title: '信息已认证',
    subtitle: '信息认证已通过审核',
  },
  [CompanyVerifyStatus.Review]: {
    title: '审核中',
    subtitle: '当前提交信息正在审核中，请耐心等待',
  },
  [CompanyVerifyStatus.Rejected]: {
    title: '当前信息审核未通过',
    subtitle: '请修改后再次提交',
  },
}
export const CompanyVerifiedStatus: string[] = [
  CompanyVerifyStatus.Verified,
  CompanyVerifyStatus.Review,
]

export const CompanyTypeMap = {
  [CompanyType.Company]: '企业', // 公司
  [CompanyType.Proprietorship]: '个体工商户', // 个体工商户
}

export const FRAMER_MOTION_LIST_ITEM_VARIANTS = {
  hidden: { scale: 0.8, opacity: 0 },
  show: { scale: 1, opacity: 1, transition: { type: 'spring' } },
}

export const STAGGER_CHILD_VARIANTS = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, type: 'spring' } },
}

export const SWIPE_REVEAL_ANIMATION_SETTINGS = {
  initial: { height: 0 },
  animate: { height: 'auto' },
  exit: { height: 0 },
  transition: { duration: 0.2, bounce: 0 },
}

export const FADE_IN_ANIMATION_SETTINGS = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2 },
}

export const COLOR_MODE = {
  light: 'light',
  dark: 'dark',
}
export const UI_COLOR_MODE_KEY = 'ui-color-mode'

export const APP_LIST_QUERY_KEY = ['appListQuery']

export enum BundleType {
  'cloud' = 'cloud',
  'storage' = 'storage',
  'mini-programs' = 'mini-programs',
  'store' = 'store',
  'band-width' = 'band-width',
  'database' = 'database',
}

export const BundleTypeText: Record<string, string> = {
  [BundleType.cloud]: '云服务',
  [BundleType.storage]: '云存储',
  [BundleType.database]: '数据库',
  [BundleType['mini-programs']]: '小程序',
  [BundleType.store]: '云店铺',
  [BundleType['band-width']]: '云带宽',
}

export enum MINI_APP_ENV {
  'weapp' = 'weapp',
  'swan' = 'swan',
  'alipay' = 'alipay',
  'qq' = 'qq',
  'tt' = 'tt',
  'kwai' = 'kwai',
  'h5' = 'h5',
}

export const MINI_APP_ENV_TEXT: Record<string, any> = {
  [MINI_APP_ENV.weapp]: '微信小程序',
  [MINI_APP_ENV.swan]: '百度小程序',
  [MINI_APP_ENV.alipay]: '支付宝小程序',
  [MINI_APP_ENV.qq]: 'QQ小程序',
  [MINI_APP_ENV.tt]: '腾讯小程序',
  [MINI_APP_ENV.kwai]: '快手小程序',
  [MINI_APP_ENV.h5]: 'H5',
}

export enum BaseState {
  Active = 'Active',
  Inactive = 'Inactive',
}

export const BaseStateText = {
  [BaseState.Active]: '启用',
  [BaseState.Inactive]: '禁用',
}

export const BaseStateOptions = Object.keys(BaseStateText).map((key) => ({
  value: key,
  label: BaseStateText[key as BaseState],
}))
